<!--
 * @Descripttion: 头部
 * @version: 1
 * @Author: lk
 * @Date: 2019-08-07 17:20:39
 * @LastEditors: lzq
 * @LastEditTime: 2023-11-28 15:02:44
 -->
<template>
  <div class="crm_header">
    <div class="header_top">
      <div class="cell_user">
        <a class="he_btn" style="position: absolute;left: -15px;font-size: 18px;">仓储管理系统</a>
        <a target="_blank" class="mr-4 ml-4 cursor-pointer" @click="download">
          <i class="el-icon-reading"></i>
          操作指南
        </a>
        &nbsp;&nbsp;
        <span class="mr-4" style="font-size: 14px" >{{
            customerName
          }}</span>
        &nbsp;&nbsp;
        <el-dropdown trigger="click">
            <span class="mr-2 ml-2 el-dropdown-link cursor-default">
             <i class="el-icon-user avatar-icon"></i>&nbsp;
              <span>{{ $store.state.user.userInfo.nickName }} </span>
              <i class="el-icon-caret-bottom"> </i>
            </span>
          <el-dropdown-menu slot="dropdown">
            <router-link to="/user/profile">
              <el-dropdown-item>个人中心</el-dropdown-item>
            </router-link>
            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

      </div>
    </div>
    <tags-view />
  </div>
</template>

<script>
// import sessionUtil from './../../utils/sessionUtil'
import { getOperateFile } from '@/api/common/index'

import TagsView from './TagsView/index.vue'
import { removeToken } from "../../utils/auth";
import { getCompanyInfo } from "../../api/company";
export default {
  components: {
    TagsView
  },
  data() {
    return {
      customerName: '',
      msgCount: '',
      linkActiveClass: 'active',
      menuData: [],
      userInfo: {},
      isLeaderShow: false, // 显示生科和IVD的切换
      value: ''
    }
  },
  mounted() {
    console.log(this.$store.state);
    // 在这里获取用户所有的按钮权限
    // this.getBtnList()
    this.init()
  },

  methods: {
    init() {
      getCompanyInfo().then((res) => {
        this.customerName = res.data.name
      })
    },
    logout() {
      let self = this
      self.$confirm('确定退出登录吗？', '注销', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 除正式环境的其他环境
        sessionStorage.removeItem('userInfo')
        sessionStorage.removeItem('tabViews')
        removeToken()
        location.reload()
        // this.$router.push({ path: '/temp' })
      }).catch(() => { })
    },
    download() {
      this.loading = true


      const elink = document.createElement('a') // 创建个a链接元素
      elink.href = 'https://udi-software.oss-cn-shenzhen.aliyuncs.com/saas-wms/%E4%BB%93%E5%82%A8%E7%AE%A1%E7%90%86%E7%B3%BB%E7%BB%9F%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf'
      elink.style.display = 'none'
      elink.setAttribute('download', '仓储管理系统操作手册.pdf') // 文件名
      elink.setAttribute('target', '_blank')
      document.body.appendChild(elink)
      elink.click() // 触发点击方法
      URL.revokeObjectURL(elink.href) // 释放URL对象
      document.body.removeChild(elink) // 释放节点

      this.loading = false
    }
  }
}
</script>

<style>
.activeMenu {
  color: white !important;
  background-color: #84cff3 !important;
}
</style>
